<div
  [ngClass]="
        'entity-select-option' + ' '
        +
        (entitySelectorsMap[entity.value] ? getEntityValue(entity) : getSelectorFromEntityLabel(entity.label))
        +
        ' '
        +
        (isSelected(entity) ? 'selected' + ' ' : '')
        "
  (click)="selectEntity(entity.secondaryDescriptor)"
>
  <i
    [ngClass]="renderIcon(entitySelectorsMap[entity.value] ?  getEntityValue(entity) : entity.value.toLowerCase())"></i>
  <div class="hiding-block">
    <span [class]="'entity-label' + ' ' + getEntityLabelSelector(entity, isDescriptionShown)">{{entity.label}}</span>
    <span *ngIf="!!entity.secondaryDescriptor" [class]="getEntityDescriptionSelector(isDescriptionShown)"
          [appTooltipOnTruncate]="entity.description" tooltipPosition="above">{{entity.description}}</span>
  </div>
</div>
